export default {
  // / <summary>
  // / Quyền xem
  // / </summary>
  View: 1,
  // / <summary>
  // / Quyền thêm
  // / </summary>
  Add: 2,
  // / <summary>
  // / Quyền sửa
  // / </summary>
  Edit: 4,
  // / <summary>
  // / Quyền xóa
  // / </summary>
  Delete: 8,
  // / <summary>
  // / Quyền ghi sổ
  // / </summary>
  Posted: 16,
  // / <summary>
  // / Quyền bỏ ghi
  // / </summary>
  UnPost: 32,
  // / <summary>
  // / Quyền in
  // / </summary>
  Print: 64,
  // / <summary>
  // / Phát hành hóa đơn
  // / </summary>
  ReleaseEInvoice: 128,
  // / <summary>
  // / Gửi hóa đơn
  // / </summary>
  SendInvoice: 256,
  // / <summary>
  // / Chuyển thành chứng từ giấy
  // / </summary>
  ConvertIntoPaperVoucher: 512,
  // / <summary>
  // / Tải hóa đơn
  // / </summary>
  DownloadInvoice: 1024,
  // / <summary>
  // / Hủy hóa đơn
  // / </summary>
  CancelInvoice: 2048,

  // / <summary>
  // / Sao lưu dữ liệu
  // / </summary>
  BackupData: 4096,

  // / <summary>
  // / Phục hồi dữ liệu
  // / </summary>
  RestoreData: 8192,

  // / <summary>
  // / Thêm mới dữ liệu
  // / </summary>
  CreateData: 16384,

  // / <summary>
  // / Thêm mới dữ liệu năm trước
  // / </summary>
  CreateDataPrevYear: 32768,

  // / <summary>
  // / Xóa dữ liệu
  // / </summary>
  DeleteData: 65536,

  // / <summary>
  // / Đổi tên dữ liệu
  // / </summary>
  RenameData: 131072,

  // / <summary>
  // / Phục hồi chứng từ
  // / </summary>
  RestoreVoucher: 262144,
  // / <summary>
  // / bảo trì
  // / </summary>
  RebuildData: 210801,
};
